export const ItemDescription = ({ description }: { description?: string }) => {
  return (
    <div className="tw:h-[75px] tw:line-clamp-3 tw:my-4 tw:text-[#49516f] tw:text-base tw:leading-relaxed">
      {description || ""}
    </div>
  );
};
